import React, { useEffect, useState, useCallback} from "react";
import { Link, useLocation } from "react-router-dom";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import api from "../api/axios";
import homeapi from "../api/homeapi";
import { useAuth } from "../context/AuthContext";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

/* ═══════════════════════════════════════════
   ICONS
═══════════════════════════════════════════ */
const GridIcon      = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="1" width="6" height="6" rx="1.5" fill="currentColor"/><rect x="9" y="1" width="6" height="6" rx="1.5" fill="currentColor" opacity=".5"/><rect x="1" y="9" width="6" height="6" rx="1.5" fill="currentColor" opacity=".5"/><rect x="9" y="9" width="6" height="6" rx="1.5" fill="currentColor" opacity=".5"/></svg>;
const UsersIcon     = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M1 13c0-2.5 2.2-4.5 5-4.5s5 2 5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="12" cy="5" r="2" stroke="currentColor" strokeWidth="1.3"/><path d="M14 13c0-2-1.3-3.6-3-4.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>;
const TruckIcon     = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="5" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5"/><path d="M11 7h2l2 3v2h-4V7z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><circle cx="4" cy="13" r="1.5" fill="currentColor"/><circle cx="12" cy="13" r="1.5" fill="currentColor"/></svg>;
const TicketIcon    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="4" width="14" height="8" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M5 8h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const MoneyIcon     = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M8 1v14M5 4h4.5a2 2 0 010 4H5m0 0h5a2 2 0 010 4H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const ChartIcon     = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M1 12l4-4 3 2 4-5 3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const CogIcon       = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.2 3.2l1.4 1.4M11.4 11.4l1.4 1.4M3.2 12.8l1.4-1.4M11.4 4.6l1.4-1.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const LogoutIcon    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M6 2H3a1 1 0 00-1 1v10a1 1 0 001 1h3M10 11l3-3-3-3M13 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const CheckIcon     = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8l4 4 6-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const CloseIcon     = () => <svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const PhoneIcon     = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M3 2h3l1.5 3.5-2 1a9 9 0 004 4l1-2 3.5 1.5V13a1 1 0 01-1 1C5 14 2 8 2 3a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/></svg>;
const MailIcon      = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.3"/><path d="M1 6l7 4 7-4" stroke="currentColor" strokeWidth="1.3"/></svg>;
const KeyIcon       = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="7" r="3.5" stroke="currentColor" strokeWidth="1.5"/><path d="M9 9.5l5 5M11.5 12l1.5 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const XCircleIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.5"/><path d="M5.5 5.5l5 5M10.5 5.5l-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const DocIcon       = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="2" y="1" width="10" height="13" rx="1.5" stroke="currentColor" strokeWidth="1.3"/><path d="M5 5h5M5 8h5M5 11h3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/><path d="M10 1v3.5H14" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/></svg>;
const ExternalIcon  = () => <svg width="11" height="11" viewBox="0 0 16 16" fill="none"><path d="M6 2H2v12h12v-4M8 8l6-6M10 2h4v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const GroupIcon     = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.3"/><path d="M1 14c0-2.5 2.2-4.5 5-4.5s5 2 5 4.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/><circle cx="12" cy="5" r="2" stroke="currentColor" strokeWidth="1.2"/><path d="M14 14c0-2-1.3-3.5-3-4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg>;
const WhatsAppIcon  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>;
const CarIcon       = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="6" width="14" height="7" rx="2" stroke="currentColor" strokeWidth="1.5"/><circle cx="4.5" cy="13.5" r="1.5" fill="currentColor"/><circle cx="11.5" cy="13.5" r="1.5" fill="currentColor"/><path d="M1 9l2-5h10l2 5" stroke="currentColor" strokeWidth="1.5"/></svg>;
const FuelIcon      = () => <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M3 2h7l3 3v9H3V2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/><path d="M6 6h3M6 9h3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>;
const StarIcon      = () => <svg width="11" height="11" viewBox="0 0 16 16" fill="none"><path d="M8 1l2.1 4.3L15 6.1l-3.5 3.4.8 4.8L8 12l-4.3 2.3.8-4.8L1 6.1l4.9-.8L8 1z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/></svg>;

/* ═══════════════════════════════════════════
   NAV
═══════════════════════════════════════════ */
const NAV_ITEMS = [
  { to: "/admin",              icon: <GridIcon />,   label: "Dashboard"     },
  { to: "/admin/users",        icon: <UsersIcon />,  label: "Utilisateurs"  },
  { to: "/admin/transporters", icon: <TruckIcon />,  label: "Transporteurs" },
  { to: "/admin/bookings",     icon: <TicketIcon />, label: "Réservations"  },
  { to: "/admin/revenue",      icon: <ChartIcon />,  label: "Revenus"       },
  { to: "/admin/settings",     icon: <CogIcon />,    label: "Paramètres"    },
];

/* ═══════════════════════════════════════════
   HELPERS
═══════════════════════════════════════════ */
const statusLabel = (status) => {
  const map = { pending:"En attente", approved:"Approuvé", rejected:"Rejeté", confirmed:"Confirmé", cancelled:"Annulé", PENDING:"En attente", APPROVED:"Approuvé", REJECTED:"Rejeté", ACTIVE:"Actif", SUCCESS:"Payé", success:"Payé" };
  return map[status] ?? status;
};
const statusVariant = (status) => {
  const map = { confirmed:"success", approved:"success", APPROVED:"success", ACTIVE:"success", SUCCESS:"success", success:"success", pending:"warning", PENDING:"warning", cancelled:"danger", rejected:"danger", REJECTED:"danger" };
  return map[status] ?? "neutral";
};
const getPhotoUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  const BASE = `${homeapi.defaults.baseURL}`;
  return `${BASE}${url.startsWith("/") ? "" : "/"}${url}`;
};

/* ═══════════════════════════════════════════
   SHARED UI
═══════════════════════════════════════════ */
const Avatar = ({ name, size = 30 }) => {
  const initials = name ? name.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase() : "?";
  return (
    <span style={{ width: size, height: size, borderRadius: "50%", background: "linear-gradient(135deg,#1e3a2f,#16181f)", border: "1px solid rgba(74,222,128,0.18)", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.32, fontWeight: 700, color: "#4ade80", flexShrink: 0, letterSpacing: -0.5 }}>
      {initials}
    </span>
  );
};

const Badge = ({ children, variant = "neutral" }) => {
  const v = {
    warning: { background: "rgba(251,191,36,0.12)",  color: "#fbbf24", border: "rgba(251,191,36,0.2)"  },
    success: { background: "rgba(74,222,128,0.12)",  color: "#4ade80", border: "rgba(74,222,128,0.2)"  },
    danger:  { background: "rgba(248,113,113,0.12)", color: "#f87171", border: "rgba(248,113,113,0.2)" },
    info:    { background: "rgba(96,165,250,0.12)",  color: "#60a5fa", border: "rgba(96,165,250,0.2)"  },
    neutral: { background: "rgba(139,143,168,0.1)",  color: "#8b8fa8", border: "rgba(139,143,168,0.2)" },
    purple:  { background: "rgba(167,139,250,0.12)", color: "#a78bfa", border: "rgba(167,139,250,0.2)" },
  };
  const c = v[variant] || v.neutral;
  return <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 6, fontWeight: 600, background: c.background, color: c.color, border: `0.5px solid ${c.border}`, fontFamily: "'DM Mono', monospace" }}>{children}</span>;
};

const StatCard = ({ icon, value, label, color }) => {
  const map = { green: { bg: "rgba(74,222,128,0.1)", fg: "#4ade80" }, blue: { bg: "rgba(96,165,250,0.1)", fg: "#60a5fa" }, amber: { bg: "rgba(251,191,36,0.1)", fg: "#fbbf24" }, purple: { bg: "rgba(167,139,250,0.1)", fg: "#a78bfa" }, teal: { bg: "rgba(52,211,153,0.1)", fg: "#34d399" } };
  const c = map[color] || map.green;
  return (
    <div style={s.statCard} className="stat-card">
      <div style={{ ...s.statIcon, background: c.bg, color: c.fg }}>{icon}</div>
      <div style={s.statValue}>{value}</div>
      <div style={s.statLabel}>{label}</div>
    </div>
  );
};

const Toast = ({ toast }) => {
  if (!toast) return null;
  return (
    <div style={s.toast} className="admin-toast">
      <span style={{ ...s.toastDot, background: toast.type === "success" ? "#4ade80" : "#f87171" }} />
      {toast.message}
    </div>
  );
};

/* ═══════════════════════════════════════════
   SIDEBAR
═══════════════════════════════════════════ */
const SidebarContent = ({ logout, close }) => {
  const location = useLocation();
  return (
    <div style={s.sidebarInner}>
      <div style={s.sidebarLogoWrap}>
        <div style={s.sidebarLogo}>Trans<span style={{ color: "#4ade80" }}>Tigo</span></div>
        <span style={s.adminPill}>Admin</span>
      </div>
      <nav style={s.nav}>
        {NAV_ITEMS.map(({ to, label, icon }) => {
          const active = location.pathname === to;
          return (
            <Link key={to} to={to} onClick={close}
              style={{ ...s.navItem, ...(active ? s.navItemActive : {}) }} className="nav-link">
              <span style={{ ...s.navIcon, color: active ? "#4ade80" : "#8b8fa8" }}>{icon}</span>
              {label}
              {active && <div style={s.navActiveBar} />}
            </Link>
          );
        })}
      </nav>
      <div style={s.sidebarFooter}>
        <button style={s.logoutBtn} onClick={logout} className="logout-btn">
          <LogoutIcon /> Déconnexion
        </button>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════
   PAYMENT MODALS
═══════════════════════════════════════════ */
const ApprovePaymentModal = ({ request, onClose, onSuccess }) => {
  const [codePaiement, setCodePaiement] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const handleApprove = async () => {
    if (!codePaiement.trim()) { setErr("Le code de paiement est obligatoire."); return; }
    setLoading(true); setErr("");
    try { await api.post(`/admin/payment-requests/${request.id}/approve`, { codePaiment: codePaiement }); onSuccess("approve"); }
    catch (e) { setErr(e?.response?.data?.error || "Erreur lors de l'approbation."); }
    setLoading(false);
  };

  return (
    <div style={s.overlay} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={s.modal}>
        <div style={s.modalHeader}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ ...s.modalIconWrap, background: "rgba(74,222,128,0.12)", color: "#4ade80" }}><CheckIcon /></div>
            <div>
              <div style={s.modalTitle}>Approuver le paiement</div>
              <div style={s.modalSub}>Saisir le code de confirmation</div>
            </div>
          </div>
          <button style={s.closeBtn} onClick={onClose}><CloseIcon /></button>
        </div>
        <div style={s.modalBody}>
          <div style={s.requestSummary}>
            <div style={s.summaryRow}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Avatar name={request.transporter || request.transporterName} size={34} />
                <div>
                  <div style={s.summaryName}>{request.transporter || request.transporterName}</div>
                  <div style={s.summarySub}>Transporteur</div>
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={s.summaryAmount}>{Number(request.amount).toLocaleString()} MGA</div>
                <div style={s.summarySub}>Montant demandé</div>
              </div>
            </div>
            <div style={s.summaryDivider} />
            <div style={s.summaryGrid}>
              {request.nomOperateur && <div style={s.summaryItem}><div style={s.summaryItemLabel}>Opérateur</div><div style={s.summaryItemVal}><span style={s.operatorTag}>{request.nomOperateur}</span></div></div>}
              {request.numeroOperateur && <div style={s.summaryItem}><div style={s.summaryItemLabel}>Numéro</div><div style={{ ...s.summaryItemVal, fontFamily: "'DM Mono', monospace", color: "#e8e9ed" }}><PhoneIcon /> {request.numeroOperateur}</div></div>}
              {request.motif && <div style={{ ...s.summaryItem, gridColumn: "1 / -1" }}><div style={s.summaryItemLabel}>Motif</div><div style={{ ...s.summaryItemVal, color: "#8b8fa8" }}>{request.motif}</div></div>}
            </div>
          </div>
          <div style={s.codeSection}>
            <div style={s.codeLabel}><KeyIcon /> Code de confirmation *</div>
            <p style={s.codeHint}>Effectuez le transfert via {request.nomOperateur || "Mobile Money"} vers le <strong style={{ color: "#e8e9ed" }}>{request.numeroOperateur || "numéro indiqué"}</strong>, puis saisissez la référence de transaction.</p>
            <input style={{ ...s.codeInput, ...(err ? s.codeInputError : {}) }} placeholder="Ex : REF-XXXXXXXX" value={codePaiement} onChange={e => { setCodePaiement(e.target.value); setErr(""); }} autoFocus />
            {err && <div style={s.errMsg}><XCircleIcon /> {err}</div>}
          </div>
        </div>
        <div style={s.modalFooter}>
          <button style={s.cancelBtn} onClick={onClose} disabled={loading}>Annuler</button>
          <button style={s.approveBtn} onClick={handleApprove} disabled={loading || !codePaiement.trim()}>
            {loading ? <><span style={s.spinner} /> Traitement…</> : <><CheckIcon /> Confirmer</>}
          </button>
        </div>
      </div>
    </div>
  );
};

const RejectPaymentModal = ({ request, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const handleReject = async () => {
    setLoading(true); setErr("");
    try { await api.post(`/admin/payment-requests/${request.id}/reject`); onSuccess("reject"); }
    catch (e) { setErr(e?.response?.data?.error || "Erreur lors du rejet."); }
    setLoading(false);
  };
  return (
    <div style={s.overlay} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ ...s.modal, maxWidth: 400 }}>
        <div style={s.modalHeader}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ ...s.modalIconWrap, background: "rgba(248,113,113,0.12)", color: "#f87171" }}><XCircleIcon /></div>
            <div><div style={s.modalTitle}>Rejeter la demande</div><div style={s.modalSub}>Cette action est irréversible</div></div>
          </div>
          <button style={s.closeBtn} onClick={onClose}><CloseIcon /></button>
        </div>
        <div style={s.modalBody}>
          <div style={s.rejectWarning}>
            <div style={s.rejectWarningText}>Vous êtes sur le point de rejeter la demande de <strong style={{ color: "#e8e9ed" }}>{request.transporter || request.transporterName}</strong> pour <strong style={{ color: "#f87171" }}>{Number(request.amount).toLocaleString()} MGA</strong>.</div>
          </div>
          {err && <div style={{ ...s.errMsg, marginTop: 10 }}><XCircleIcon /> {err}</div>}
        </div>
        <div style={s.modalFooter}>
          <button style={s.cancelBtn} onClick={onClose} disabled={loading}>Annuler</button>
          <button style={s.rejectBtn} onClick={handleReject} disabled={loading}>
            {loading ? <><span style={{ ...s.spinner, borderTopColor: "#f87171" }} /> Rejet…</> : <><XCircleIcon /> Confirmer le rejet</>}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════
   RENTAL CAR DETAIL MODAL
═══════════════════════════════════════════ */
const RentalCarDetailModal = ({ car, onClose }) => {
  const mainPhoto = getPhotoUrl(car.photos?.[0]);
  const fuelColor = { Essence:"#f87171", Diesel:"#fbbf24", Hybride:"#4ade80", "Électrique":"#60a5fa", GPL:"#a78bfa" };
  return (
    <div style={s.overlay} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ ...s.modal, maxWidth: 500, maxHeight: "90vh", overflowY: "auto" }}>
        <div style={s.modalHeader}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ ...s.modalIconWrap, background: "rgba(167,139,250,0.12)", color: "#a78bfa" }}><CarIcon /></div>
            <div>
              <div style={s.modalTitle}>{car.brand} {car.model} {car.year && `(${car.year})`}</div>
              <div style={s.modalSub}>{car.licensePlate || "Pas d'immatriculation"}</div>
            </div>
          </div>
          <button style={s.closeBtn} onClick={onClose}><CloseIcon /></button>
        </div>
        <div style={s.modalBody}>
          {mainPhoto && (
            <div style={{ borderRadius: 10, overflow: "hidden", marginBottom: 16, height: 180, background: "#13151b" }}>
              <img src={mainPhoto} alt={`${car.brand} ${car.model}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            </div>
          )}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
            {[
              { label: "Statut",        value: <Badge variant={car.status === "available" ? "success" : "warning"}>{car.status === "available" ? "Disponible" : car.status ?? "Actif"}</Badge> },
              { label: "Prix / jour",   value: <span style={{ fontFamily: "'DM Mono',monospace", color: "#a78bfa", fontWeight: 700 }}>{Number(car.dailyPrice).toLocaleString()} MGA</span> },
              { label: "Carburant",     value: <span style={{ color: fuelColor[car.fuelType] ?? "#8b8fa8" }}>{car.fuelType || "—"}</span> },
              { label: "Places",        value: `${car.seats || "—"} places` },
              { label: "Réservations",  value: `${car.bookings ?? 0} résa.` },
              { label: "Commission (10%)", value: <span style={{ color: "#4ade80", fontWeight: 700 }}>{Math.round(car.dailyPrice * 0.1).toLocaleString()} MGA/j</span> },
            ].map(({ label, value }) => (
              <div key={label} style={{ background: "#13151b", border: "0.5px solid #2a2d38", borderRadius: 8, padding: "10px 12px" }}>
                <div style={{ fontSize: 10, color: "#8b8fa8", textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700, marginBottom: 5 }}>{label}</div>
                <div style={{ fontSize: 13, color: "#c8cad8" }}>{value}</div>
              </div>
            ))}
          </div>
          {car.features?.length > 0 && (
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 10, color: "#8b8fa8", textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700, marginBottom: 8 }}>Équipements</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {car.features.map(f => <span key={f} style={{ fontSize: 11, background: "#1e2029", color: "#8b8fa8", padding: "3px 8px", borderRadius: 5, border: "0.5px solid #2a2d38" }}>{f}</span>)}
              </div>
            </div>
          )}
          {car.description && (
            <div style={{ background: "#13151b", border: "0.5px solid #2a2d38", borderRadius: 8, padding: "12px 14px", fontSize: 12, color: "#8b8fa8", lineHeight: 1.6 }}>
              {car.description}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════
   TRANSPORTER DETAIL PANEL
═══════════════════════════════════════════ */
const DETAIL_TABS = ["Informations", "Documents", "Finances", "Transactions"];

const TransporterDetailPanel = ({ transporterId, onClose, onValidated, onRejected }) => {
  const [data,       setData]       = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [tab,        setTab]        = useState("Informations");
  const [actionLoad, setActionLoad] = useState(null);
  const [docModal,   setDocModal]   = useState(null);

  useEffect(() => {
    if (!transporterId) return;
    setLoading(true); setTab("Informations");
    api.get(`/admin/transporter/${transporterId}/detail`)
      .then(r => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [transporterId]);

  const handleValidate = async () => {
    setActionLoad("validate");
    try { await api.post(`/admin/validate-transporter/${transporterId}`); onValidated && onValidated(transporterId); onClose(); }
    catch {}
    setActionLoad(null);
  };

  const handleReject = async () => {
    setActionLoad("reject");
    try { await api.post(`/admin/reject-transporter/${transporterId}`); onRejected && onRejected(transporterId); onClose(); }
    catch {}
    setActionLoad(null);
  };

  const isPending = data?.status === "PENDING";
  const docBaseUrl = `${homeapi.defaults.baseURL}/uploads/transporters/`;
  const InfoRow = ({ label, value }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <span style={{ fontSize: 10, color: "#8b8fa8", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.6px" }}>{label}</span>
      <span style={{ fontSize: 13, color: "#c8cad8", fontWeight: 500 }}>{value ?? "—"}</span>
    </div>
  );

  const MiniStat = ({ icon, value, label, color }) => (
    <div style={{ background: "#0f1117", border: "0.5px solid #2a2d38", borderRadius: 10, padding: "12px 14px" }}>
      <div style={{ color, width: 26, height: 26, background: `${color}18`, borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 8 }}>{icon}</div>
      <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 15, fontWeight: 700, color: "#e8e9ed", letterSpacing: -0.3 }}>{value}</div>
      <div style={{ fontSize: 10.5, color: "#8b8fa8", marginTop: 2 }}>{label}</div>
    </div>
  );

  return (
    <>
      <div style={dp.backdrop} onClick={onClose} />
      <div style={dp.panel} className="detail-panel">
        <div style={dp.header}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1, minWidth: 0 }}>
            {data && <Avatar name={data.name} size={44} />}
            {loading
              ? <div style={{ height: 18, width: 150, background: "#2a2d38", borderRadius: 6 }} />
              : <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 16, fontWeight: 700, color: "#e8e9ed", letterSpacing: -0.4 }}>{data?.name}</div>
                  <div style={{ display: "flex", gap: 6, marginTop: 5, flexWrap: "wrap" }}>
                    <Badge variant={statusVariant(data?.status)}>{statusLabel(data?.status)}</Badge>
                    {data?.company && <span style={{ fontSize: 11, color: "#8b8fa8", background: "#1e2029", padding: "2px 8px", borderRadius: 6, display: "flex", alignItems: "center", gap: 4 }}><TruckIcon /> {data.company}</span>}
                  </div>
                </div>
            }
          </div>
          <button style={dp.closeBtn} onClick={onClose}><CloseIcon /></button>
        </div>

        {!loading && data && (
          <div style={dp.contactBar}>
            <a href={`tel:${data.phone}`} style={dp.chip} className="dp-chip"><PhoneIcon /> {data.phone}</a>
            <a href={`mailto:${data.email}`} style={dp.chip} className="dp-chip"><MailIcon /> <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 150 }}>{data.email}</span></a>
            {data.phone && (
              <a href={`https://wa.me/${data.phone.replace(/\D/g, "")}`} target="_blank" rel="noreferrer"
                style={{ ...dp.chip, color: "#4ade80", borderColor: "rgba(74,222,128,0.2)" }} className="dp-chip">
                <WhatsAppIcon /> WhatsApp
              </a>
            )}
          </div>
        )}

        <div style={dp.tabBar}>
          {DETAIL_TABS.map(t => (
            <button key={t} style={{ ...dp.tab, ...(tab === t ? dp.tabActive : {}) }} onClick={() => setTab(t)} className="dp-tab">
              {t}
              {t === "Documents" && data?.documentsCount > 0 && <span style={dp.tabBadge}>{data.documentsCount}</span>}
              {t === "Transactions" && (data?.transactions?.length ?? 0) > 0 && <span style={dp.tabBadge}>{data.transactions.length}</span>}
            </button>
          ))}
        </div>

        <div style={dp.body}>
          {loading ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: 200, gap: 12 }}>
              <span style={{ display: "inline-block", width: 20, height: 20, border: "2px solid #2a2d38", borderTopColor: "#4ade80", borderRadius: "50%", animation: "spin 0.6s linear infinite" }} />
              <span style={{ fontSize: 12, color: "#8b8fa8" }}>Chargement…</span>
            </div>
          ) : !data ? (
            <p style={{ color: "#f87171", textAlign: "center", padding: 40, fontSize: 13 }}>Impossible de charger les données.</p>
          ) : (
            <>
              {tab === "Informations" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  <div style={dp.section}>
                    <div style={dp.sectionTitle}>Identité & Contact</div>
                    <div style={dp.infoGrid}>
                      <InfoRow label="Nom complet"  value={data.name} />
                      <InfoRow label="Email"         value={data.email} />
                      <InfoRow label="Téléphone"     value={data.phone} />
                      <InfoRow label="Inscrit le"    value={data.createdAt ? new Date(data.createdAt).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" }) : "—"} />
                      <InfoRow label="Statut"        value={<Badge variant={statusVariant(data.status)}>{statusLabel(data.status)}</Badge>} />
                      <InfoRow label="Compte validé" value={data.isValidated ? <Badge variant="success">Oui</Badge> : <Badge variant="warning">Non</Badge>} />
                    </div>
                  </div>
                  <div style={dp.section}>
                    <div style={dp.sectionTitle}>Société & Véhicule</div>
                    <div style={dp.infoGrid}>
                      <InfoRow label="Société"       value={data.company} />
                      <InfoRow label="Type véhicule" value={data.vehicleType} />
                      <InfoRow label="Capacité"      value={data.capacity ? `${data.capacity} places` : null} />
                      <InfoRow label="Coopérative"   value={data.cooperativeName} />
                    </div>
                  </div>
                  <div style={dp.section}>
                    <div style={dp.sectionTitle}>Résumé activité</div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                      <MiniStat icon={<TicketIcon />} value={data.totalBookings ?? 0} label="Réservations" color="#fbbf24" />
                      <MiniStat icon={<MoneyIcon />}  value={`${Number(data.totalRevenue ?? 0).toLocaleString()}`} label="MGA générés" color="#4ade80" />
                      <MiniStat icon={<TruckIcon />}  value={data.totalTrips ?? 0} label="Trajets" color="#60a5fa" />
                      <MiniStat icon={<GroupIcon />}  value={data.transactions?.length ?? 0} label="Transactions" color="#a78bfa" />
                    </div>
                  </div>
                </div>
              )}

              {tab === "Documents" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  <p style={{ fontSize: 12, color: "#8b8fa8", margin: "0 0 4px" }}>Cliquez sur un document pour le visualiser.</p>
                  {[
                    { key: "cinDocument",           label: "Pièce d'identité (CIN / Passeport)", required: true  },
                    { key: "permisDocument",         label: "Permis de conduire",                  required: true  },
                    { key: "matriculationDocument",  label: "Carte de matriculation",              required: true  },
                    { key: "cooperativeDocument",    label: "Attestation de coopérative",          required: false },
                  ].map(({ key, label, required }) => {
                    const filename = data[key];
                    const url = filename ? `${docBaseUrl}${filename}` : null;
                    return (
                      <div key={key} style={{ ...dp.docRow, opacity: url ? 1 : 0.5 }}>
                        <div style={{ width: 34, height: 34, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", background: url ? "rgba(74,222,128,0.1)" : "rgba(139,143,168,0.08)", color: url ? "#4ade80" : "#4a4d5e", flexShrink: 0 }}>
                          <DocIcon />
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: url ? "#e8e9ed" : "#4a4d5e" }}>{label}</div>
                          <div style={{ fontSize: 11, color: "#8b8fa8", marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {url ? filename : (required ? "Non fourni ⚠️" : "Non fourni (facultatif)")}
                          </div>
                        </div>
                        {url && (
                          <button style={dp.docBtn} onClick={() => setDocModal({ url, label })} className="dp-doc-btn">
                            <ExternalIcon /> Voir
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {tab === "Finances" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    {[
                      { label: "Profit total généré",      value: `${Number(data.totalRevenue ?? 0).toLocaleString()} MGA`, color: "#4ade80" },
                      { label: "Transactions approuvées",  value: (data.transactions || []).filter(t => t.status?.toLowerCase() === "approved").length, color: "#60a5fa" },
                      { label: "Montant versé",            value: `${Number((data.transactions || []).filter(t => t.status?.toLowerCase() === "approved").reduce((a, t) => a + Number(t.amount || 0), 0)).toLocaleString()} MGA`, color: "#a78bfa" },
                      { label: "En attente versement",    value: `${Number((data.transactions || []).filter(t => t.status?.toLowerCase() === "pending").reduce((a, t) => a + Number(t.amount || 0), 0)).toLocaleString()} MGA`, color: "#fbbf24" },
                    ].map(({ label, value, color }) => (
                      <div key={label} style={{ background: "#0f1117", border: `0.5px solid ${color}22`, borderRadius: 10, padding: "14px 16px" }}>
                        <div style={{ fontSize: 10, color: "#8b8fa8", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 700, marginBottom: 8 }}>{label}</div>
                        <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 16, fontWeight: 700, color, letterSpacing: -0.4 }}>{value}</div>
                      </div>
                    ))}
                  </div>
                  <div style={dp.section}>
                    <div style={dp.sectionTitle}>Réservations</div>
                    {(data.bookings || []).length === 0
                      ? <p style={dp.empty}>Aucune réservation</p>
                      : <div style={{ overflowX: "auto" }}>
                          <table style={dp.table}>
                            <thead><tr>{["Client","Trajet","Montant","Reference","Statut","Date"].map(h => <th key={h} style={dp.th}>{h}</th>)}</tr></thead>
                            <tbody>
                              {(data.bookings || []).map((b, i) => (
                                <tr key={i} className="trow">
                                  <td style={dp.td}><span style={{ color: "#e8e9ed", fontWeight: 600, fontSize: 12 }}>{b.client}</span></td>
                                  <td style={{ ...dp.td, color: "#8b8fa8", fontSize: 12 }}>{b.route}</td>
                                  <td style={dp.td}><span style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, color: "#4ade80", fontWeight: 600 }}>{Number(b.amount).toLocaleString()}</span></td>
                                  <td style={dp.td}><span style={{ color: "#e8e9ed", fontWeight: 600, fontSize: 12 }}>{b.reference}</span></td>
                                  <td style={dp.td}><Badge variant={statusVariant(b.status)}>{statusLabel(b.status)}</Badge></td>
                                  <td style={{ ...dp.td, color: "#8b8fa8", fontSize: 11 }}>{b.date ? new Date(b.date).toLocaleDateString("fr-FR") : "—"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                    }
                  </div>
                </div>
              )}

              {tab === "Transactions" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  {(data.transactions || []).length === 0
                    ? <p style={dp.empty}>Aucune transaction</p>
                    : (data.transactions || []).map((t, i) => {
                        const st = (t.status || "pending").toLowerCase();
                        const color = st === "approved" ? "#4ade80" : st === "pending" ? "#fbbf24" : "#f87171";
                        return (
                          <div key={i} style={{ background: "#0f1117", border: "0.5px solid #2a2d38", borderRadius: 10, padding: "12px 14px", display: "flex", gap: 12, alignItems: "flex-start" }}>
                            <div style={{ width: 32, height: 32, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", background: `${color}12`, color, flexShrink: 0 }}><MoneyIcon /></div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                                <span style={{ fontSize: 14, fontWeight: 700, color: "#e8e9ed", fontFamily: "'DM Mono', monospace" }}>{Number(t.amount).toLocaleString()} MGA</span>
                                <Badge variant={statusVariant(t.status)}>{statusLabel(t.status)}</Badge>
                                {t.nomOperateur && <span style={{ fontSize: 10.5, background: "rgba(96,165,250,0.1)", color: "#60a5fa", padding: "2px 7px", borderRadius: 5, border: "0.5px solid rgba(96,165,250,0.2)", fontWeight: 600 }}>{t.nomOperateur}</span>}
                              </div>
                              <div style={{ fontSize: 11, color: "#8b8fa8", marginTop: 4, display: "flex", gap: 10, flexWrap: "wrap" }}>
                                {t.numeroOperateur && <span>📱 {t.numeroOperateur}</span>}
                                {t.motif && <span>— {t.motif}</span>}
                                {t.createdAt && <span>🗓 {new Date(t.createdAt).toLocaleDateString("fr-FR")}</span>}
                              </div>
                              {t.codePaiement && (
                                <div style={{ marginTop: 5, fontSize: 11, color: "#4ade80", fontFamily: "'DM Mono', monospace" }}>🔑 Code : {t.codePaiement}</div>
                              )}
                            </div>
                          </div>
                        );
                      })
                  }
                </div>
              )}
            </>
          )}
        </div>

        {isPending && !loading && (
          <div style={dp.footer}>
            <div style={{ fontSize: 11, color: "#8b8fa8", marginBottom: 10 }}>Ce transporteur est en attente de validation.</div>
            <div style={{ display: "flex", gap: 10 }}>
              <button style={dp.rejectBtn} onClick={handleReject} disabled={!!actionLoad}>
                {actionLoad === "reject" ? "…" : <><XCircleIcon /> Rejeter</>}
              </button>
              <button style={dp.validateBtn} onClick={handleValidate} disabled={!!actionLoad}>
                {actionLoad === "validate" ? "…" : <><CheckIcon /> Valider le compte</>}
              </button>
            </div>
          </div>
        )}
      </div>

      {docModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 600, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }} onClick={() => setDocModal(null)}>
          <div style={{ background: "#16181f", border: "0.5px solid #2a2d38", borderRadius: 14, padding: 20, width: "100%", maxWidth: 680, maxHeight: "90vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: "#e8e9ed" }}>{docModal.label}</span>
              <div style={{ display: "flex", gap: 8 }}>
                <a href={docModal.url} target="_blank" rel="noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, color: "#60a5fa", background: "rgba(96,165,250,0.1)", border: "0.5px solid rgba(96,165,250,0.2)", borderRadius: 6, padding: "5px 10px", textDecoration: "none" }}><ExternalIcon /> Ouvrir</a>
                <button style={dp.closeBtn} onClick={() => setDocModal(null)}><CloseIcon /></button>
              </div>
            </div>
            {docModal.url.match(/\.pdf$/i)
              ? <iframe src={docModal.url} style={{ width: "100%", height: 460, border: "none", borderRadius: 8 }} title={docModal.label} />
              : <img src={docModal.url} alt={docModal.label} style={{ width: "100%", maxHeight: 460, objectFit: "contain", borderRadius: 8 }} />
            }
          </div>
        </div>
      )}
    </>
  );
};

/* ═══════════════════════════════════════════
   ADMIN DASHBOARD
═══════════════════════════════════════════ */
const AdminDashboard = () => {
  const { logout } = useAuth();

  const [loading,             setLoading]             = useState(true);
  const [actionLoading,       setActionLoading]       = useState(null);
  const [showSidebar,         setShowSidebar]         = useState(false);
  const [toast,               setToast]               = useState(null);
  const [stats,               setStats]               = useState({ clients: 0, transporters: 0, bookings: 0, revenue: 0 });
  const [pendingTransporters, setPendingTransporters] = useState([]);
  const [recentBookings,      setRecentBookings]      = useState([]);
  const [revenueChart,        setRevenueChart]        = useState([]);
  const [paymentRequests,     setPaymentRequests]     = useState([]);
  const [carpools,            setCarpools]            = useState([]);
  const [rentalCars,          setRentalCars]          = useState([]);
  const [rentalPayments,      setRentalPayments]      = useState([]);
  const [rentalTab,           setRentalTab]           = useState("cars");
  const [approveTarget,       setApproveTarget]       = useState(null);
  const [rejectTarget,        setRejectTarget]        = useState(null);
  const [detailTransporterId, setDetailTransporterId] = useState(null);
  const [rentalDetailCar,     setRentalDetailCar]     = useState(null);

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3500);
  };

  const loadStats               = async () => { try { const r = await api.get("/admin/stats");                setStats(r.data); } catch {} };
  const loadPendingTransporters = async () => { try { const r = await api.get("/admin/pending-transporters"); setPendingTransporters(r.data); } catch {} };
  const loadRecentBookings      = async () => { try { const r = await api.get("/admin/recent-bookings");      setRecentBookings(r.data); } catch {} };
  const loadRevenueChart        = async () => { try { const r = await api.get("/admin/revenue-chart");        setRevenueChart(r.data || []); } catch { setRevenueChart([]); } };
  const loadPaymentRequests     = async () => { try { const r = await api.get("/admin/payment-requests");     setPaymentRequests(r.data); } catch { setPaymentRequests([]); } };
  const loadCarpools            = async () => { try { const r = await api.get("/admin/carpooling");           setCarpools(r.data); } catch { setCarpools([]); } };
  const loadRentalCars          = async () => { try { const r = await api.get("/admin/rentals");              setRentalCars(r.data); } catch { setRentalCars([]); } };
  const loadRentalPayments      = async () => { try { const r = await api.get("/admin/rental-payments");      setRentalPayments(r.data); } catch { setRentalPayments([]); } };

  const init = useCallback(async () => {
    setLoading(true);
    await Promise.all([loadStats(), loadPendingTransporters(), loadRecentBookings(), loadRevenueChart(), loadPaymentRequests(), loadCarpools(), loadRentalCars(), loadRentalPayments()]);
    setLoading(false);
  }, []);

  useEffect(() => { init(); }, [init]);

  useEffect(() => {
    document.body.style.overflow = showSidebar ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [showSidebar]);

  const validateTransporter = async (id) => {
    setActionLoading(id);
    try { await api.post(`/admin/validate-transporter/${id}`); await loadPendingTransporters(); await loadStats(); showToast("Transporteur validé ✓", "success"); }
    catch { showToast("Erreur lors de la validation", "danger"); }
    setActionLoading(null);
  };

  const rejectTransporter = async (id) => {
    setActionLoading(id);
    try { await api.post(`/admin/reject-transporter/${id}`); await loadPendingTransporters(); showToast("Transporteur rejeté", "danger"); }
    catch { showToast("Erreur lors du rejet", "danger"); }
    setActionLoading(null);
  };

  const handlePaymentActionSuccess = async (type) => {
    setApproveTarget(null); setRejectTarget(null);
    await loadPaymentRequests();
    showToast(type === "approve" ? "Paiement approuvé ✓" : "Demande rejetée", type === "approve" ? "success" : "danger");
  };

  const pendingCount = paymentRequests.filter(p => (p.status ?? "").toLowerCase() === "pending").length;

  const rentalTotalRevenue    = rentalPayments.filter(p => (p.status ?? "").toUpperCase() === "SUCCESS").reduce((a, p) => a + Number(p.amount || 0), 0);
  const rentalCommission      = Math.round(rentalTotalRevenue * 0.1);
  const rentalTransporterPart = Math.round(rentalTotalRevenue * 0.9);

  const chartData = {
    labels: revenueChart.map(r => r.date),
    datasets: [{
      label: "Revenus",
      data: revenueChart.map(r => r.amount),
      borderColor: "#4ade80",
      backgroundColor: "rgba(74,222,128,0.07)",
      borderWidth: 1.5,
      tension: 0.4,
      fill: true,
      pointRadius: 3,
      pointBackgroundColor: "#4ade80",
      pointBorderColor: "#16181f",
      pointBorderWidth: 2,
    }],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: { backgroundColor: "#1e2029", titleColor: "#e8e9ed", bodyColor: "#8b8fa8", borderColor: "#2a2d38", borderWidth: 1, callbacks: { label: ctx => ` ${Number(ctx.parsed.y).toLocaleString()} MGA` } },
    },
    scales: {
      x: { grid: { color: "#1a1c25" }, ticks: { color: "#8b8fa8", font: { size: 11 } } },
      y: { grid: { color: "#1a1c25" }, ticks: { color: "#8b8fa8", font: { size: 11 } } },
    },
  };

  if (loading) return (
    <div style={s.loadingScreen}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <div style={s.spinner} />
      <p style={{ color: "#8b8fa8", marginTop: 12, fontSize: 14 }}>Chargement…</p>
    </div>
  );

  return (
    <>
      <style>{globalCSS}</style>
      <div style={s.layout}>

        {showSidebar && <div style={s.overlay2} onClick={() => setShowSidebar(false)} />}

        {/* SIDEBAR */}
        <div style={{ ...s.sidebar, ...(showSidebar ? s.sidebarOpen : {}) }} className="admin-sidebar">
          <SidebarContent logout={logout} close={() => setShowSidebar(false)} />
        </div>

        {/* MAIN */}
        <div style={s.main} className="admin-main">

          {/* HEADER */}
          <div style={s.pageHeader}>
            <div>
              <h1 style={s.pageTitle}>Dashboard</h1>
              <p style={s.pageSubtitle}>Vue d'ensemble de la plateforme</p>
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <Link to="/admin/revenue"  style={s.headerBtn} className="header-btn"><ChartIcon /> Revenus</Link>
              <Link to="/admin/settings" style={s.headerBtn} className="header-btn"><CogIcon /> Paramètres</Link>
            </div>
          </div>

          {/* STATS */}
          <div style={s.statsGrid} className="stats-grid">
            <StatCard icon={<UsersIcon />}  value={stats.clients.toLocaleString()}                     label="Clients"       color="green"  />
            <StatCard icon={<TruckIcon />}  value={stats.transporters.toLocaleString()}                 label="Transporteurs" color="blue"   />
            <StatCard icon={<TicketIcon />} value={stats.bookings.toLocaleString()}                     label="Réservations"  color="amber"  />
            <StatCard icon={<MoneyIcon />}  value={`${Number(stats.revenue).toLocaleString()} MGA`}    label="Revenus"       color="purple" />
            <StatCard icon={<CarIcon />}    value={rentalCars.length}                                   label="Véhicules loc." color="teal"  />
          </div>

          {/* CHART + PENDING */}
          <div style={s.twoCol} className="two-col">
            <div style={s.card}>
              <div style={s.cardHeader}>
                <h2 style={s.cardTitle}>Revenus</h2>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <Badge variant="success">7 derniers jours</Badge>
                  <Link to="/admin/revenue" style={s.seeAll}>Voir tout →</Link>
                </div>
              </div>
              <Line data={chartData} options={chartOptions} />
            </div>

            <div style={s.card}>
              <div style={s.cardHeader}>
                <h2 style={s.cardTitle}>Transporteurs en attente</h2>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <Badge variant="warning">{pendingTransporters.length} en attente</Badge>
                  <Link to="/admin/transporters" style={s.seeAll}>Voir tout →</Link>
                </div>
              </div>
              {pendingTransporters.length === 0 ? (
                <p style={s.emptyMsg}>Aucun transporteur en attente</p>
              ) : pendingTransporters.map(t => (
                <div key={t.id} style={s.listRow}>
                  <div style={{ ...s.listRowLeft, cursor: "pointer", flex: 1, minWidth: 0 }} onClick={() => setDetailTransporterId(t.id)}>
                    <Avatar name={t.name} />
                    <div style={{ minWidth: 0 }}>
                      <div style={{ ...s.listName, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t.name}</div>
                      <div style={s.listSub}>{t.phone || "Madagascar"}</div>
                    </div>
                  </div>
                  <div style={s.btnGroup}>
                    <button style={{ ...s.btn, background: "rgba(96,165,250,0.08)", color: "#60a5fa", borderColor: "rgba(96,165,250,0.2)" }} onClick={() => setDetailTransporterId(t.id)}>Voir</button>
                    <button style={{ ...s.btn, ...s.btnApprove }} disabled={actionLoading === t.id} onClick={() => validateTransporter(t.id)}>{actionLoading === t.id ? "…" : "Valider"}</button>
                    <button style={{ ...s.btn, ...s.btnReject }} disabled={actionLoading === t.id} onClick={() => rejectTransporter(t.id)}>Rejeter</button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* PAYMENT REQUESTS */}
          <div style={s.card}>
            <div style={s.cardHeader}>
              <h2 style={s.cardTitle}>Demandes de paiement</h2>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                {pendingCount > 0 && <Badge variant="warning">{pendingCount} en attente</Badge>}
                <Badge variant="neutral">{paymentRequests.length} au total</Badge>
              </div>
            </div>
            <div style={s.tableWrap}>
              <table style={s.table}>
                <thead>
                  <tr>{["Transporteur","Montant","Opérateur","Numéro","Motif","Date","Statut","Actions"].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
                </thead>
                <tbody>
                  {paymentRequests.length === 0 ? (
                    <tr><td colSpan={8} style={{ ...s.td, textAlign: "center", color: "#8b8fa8", padding: "32px 0" }}>Aucune demande de paiement</td></tr>
                  ) : paymentRequests.map(p => {
                    const status = (p.status ?? "pending").toLowerCase();
                    const isPending = status === "pending";
                    return (
                      <tr key={p.id} className="trow">
                        <td style={s.td}>
                          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <Avatar name={p.transporter || p.transporterName} />
                            <span style={{ color: "#e8e9ed", fontWeight: 600, fontSize: 13, whiteSpace: "nowrap" }}>{p.transporter || p.transporterName || "—"}</span>
                          </div>
                        </td>
                        <td style={s.td}><span style={s.amount}>{Number(p.amount).toLocaleString()} MGA</span></td>
                        <td style={s.td}>{p.nomOperateur ? <span style={s.operatorTag}>{p.nomOperateur}</span> : <span style={{ color: "#4a4d5e", fontSize: 12 }}>—</span>}</td>
                        <td style={s.td}>{p.numeroOperateur ? <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, color: "#c8cad8", display: "flex", alignItems: "center", gap: 4, whiteSpace: "nowrap" }}><PhoneIcon />{p.numeroOperateur}</span> : <span style={{ color: "#4a4d5e", fontSize: 12 }}>—</span>}</td>
                        <td style={{ ...s.td, color: "#8b8fa8", fontSize: 12, maxWidth: 120 }}><span style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 110 }}>{p.motif || "—"}</span></td>
                        <td style={{ ...s.td, color: "#8b8fa8", fontSize: 12, whiteSpace: "nowrap" }}>{p.createdAt ? new Date(p.createdAt).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "—"}</td>
                        <td style={s.td}><Badge variant={statusVariant(status)}>{statusLabel(status)}</Badge></td>
                        <td style={s.td}>
                          {isPending ? (
                            <div style={s.btnGroup}>
                              <button style={{ ...s.btn, ...s.btnApprove, display: "flex", alignItems: "center", gap: 4 }} onClick={() => setApproveTarget(p)}><CheckIcon /> Approuver</button>
                              <button style={{ ...s.btn, ...s.btnReject, display: "flex", alignItems: "center", gap: 4 }} onClick={() => setRejectTarget(p)}><XCircleIcon /> Rejeter</button>
                            </div>
                          ) : (
                            <span style={{ fontSize: 11, color: status === "approved" ? "#4ade80" : "#f87171", display: "flex", alignItems: "center", gap: 4 }}>
                              {status === "approved" ? <CheckIcon /> : <XCircleIcon />} {statusLabel(status)}
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* LOCATION DE VÉHICULES */}
          <div style={s.card}>
            <div style={s.cardHeader}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 30, height: 30, borderRadius: 8, background: "rgba(167,139,250,0.12)", color: "#a78bfa", display: "flex", alignItems: "center", justifyContent: "center" }}><CarIcon /></div>
                <h2 style={s.cardTitle}>Location de véhicules</h2>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <Badge variant="purple">{rentalCars.length} véhicule{rentalCars.length !== 1 ? "s" : ""}</Badge>
                <Badge variant="neutral">{rentalPayments.length} paiement{rentalPayments.length !== 1 ? "s" : ""}</Badge>
              </div>
            </div>

            <div style={{ display: "grid", gap: 10, marginBottom: 18 }} className="rental-stats-grid">
              {[
                { label: "Revenus location (total)", value: `${rentalTotalRevenue.toLocaleString()} MGA`, color: "#a78bfa", hint: "Paiements confirmés" },
                { label: "Commission plateforme (10%)", value: `${rentalCommission.toLocaleString()} MGA`, color: "#4ade80", hint: "Part de l'application" },
                { label: "Part transporteurs (90%)", value: `${rentalTransporterPart.toLocaleString()} MGA`, color: "#60a5fa", hint: "Versé aux propriétaires" },
              ].map(({ label, value, color, hint }) => (
                <div key={label} style={{ background: "#13151b", border: `0.5px solid ${color}22`, borderRadius: 10, padding: "14px 16px" }}>
                  <div style={{ fontSize: 10, color: "#8b8fa8", textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700, marginBottom: 6 }}>{label}</div>
                  <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 18, fontWeight: 700, color, letterSpacing: -0.5 }}>{value}</div>
                  <div style={{ fontSize: 10.5, color: "#4a4d5a", marginTop: 4 }}>{hint}</div>
                </div>
              ))}
            </div>

            <div style={{ display: "flex", gap: 4, marginBottom: 16, background: "#13151b", borderRadius: 9, padding: 4, width: "fit-content", maxWidth: "100%", overflowX: "auto" }}>
              {[["cars", "🚗 Véhicules"], ["payments", "💳 Paiements"]].map(([tab, label]) => (
                <button key={tab} onClick={() => setRentalTab(tab)} style={{ padding: "7px 14px", borderRadius: 7, border: "none", fontFamily: "inherit", fontSize: 12, fontWeight: 600, cursor: "pointer", background: rentalTab === tab ? "#a78bfa" : "transparent", color: rentalTab === tab ? "#0f1117" : "#8b8fa8", whiteSpace: "nowrap" }}>{label}</button>
              ))}
            </div>

            {rentalTab === "cars" && (
              rentalCars.length === 0 ? (
                <p style={s.emptyMsg}>Aucun véhicule de location enregistré</p>
              ) : (
                <div style={s.tableWrap}>
                  <table style={s.table}>
                    <thead>
                      <tr>{["Véhicule","Carburant","Places","Prix/jour","Commission/jour","Réservations","Statut","Détail"].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
                    </thead>
                    <tbody>
                      {rentalCars.map((car, i) => {
                        const mainPhoto = getPhotoUrl(car.photos?.[0]);
                        const commission = Math.round(car.dailyPrice * 0.1);
                        const fuelColor = { Essence:"#f87171", Diesel:"#fbbf24", Hybride:"#4ade80", "Électrique":"#60a5fa", GPL:"#a78bfa" };
                        return (
                          <tr key={car.id ?? i} className="trow">
                            <td style={s.td}>
                              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                {mainPhoto ? (
                                  <img src={mainPhoto} alt="" style={{ width: 36, height: 36, borderRadius: 6, objectFit: "cover", flexShrink: 0, border: "0.5px solid #2a2d38" }} onError={e => { e.target.style.display = "none"; }} />
                                ) : (
                                  <div style={{ width: 36, height: 36, borderRadius: 6, background: "#1e2029", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 16 }}>🚗</div>
                                )}
                                <div>
                                  <div style={{ color: "#e8e9ed", fontWeight: 600, fontSize: 13, whiteSpace: "nowrap" }}>{car.brand} {car.model}</div>
                                  {car.year && <div style={{ fontSize: 11, color: "#8b8fa8" }}>{car.year}</div>}
                                  {car.licensePlate && <div style={{ fontSize: 10, color: "#60a5fa", fontFamily: "'DM Mono',monospace", letterSpacing: 1 }}>{car.licensePlate}</div>}
                                </div>
                              </div>
                            </td>
                            <td style={s.td}>
                              {car.fuelType ? <span style={{ fontSize: 11, color: fuelColor[car.fuelType] ?? "#8b8fa8", display: "flex", alignItems: "center", gap: 4 }}><FuelIcon />{car.fuelType}</span> : <span style={{ color: "#4a4d5e" }}>—</span>}
                            </td>
                            <td style={s.td}><span style={s.seatsTag}>{car.seats ?? "—"}</span></td>
                            <td style={s.td}><span style={{ ...s.amount, color: "#a78bfa" }}>{Number(car.dailyPrice).toLocaleString()} MGA</span></td>
                            <td style={s.td}>
                              <div>
                                <div style={{ ...s.amount, color: "#4ade80", fontSize: 12 }}>{commission.toLocaleString()} MGA</div>
                                <div style={{ fontSize: 10, color: "#4a4d5a", marginTop: 2 }}>10 % du prix</div>
                              </div>
                            </td>
                            <td style={s.td}>
                              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                <StarIcon /><span style={{ fontSize: 12, color: "#c8cad8" }}>{car.bookings ?? 0}</span>
                              </div>
                            </td>
                            <td style={s.td}><Badge variant={car.status === "available" ? "success" : "warning"}>{car.status === "available" ? "Disponible" : car.status ?? "Actif"}</Badge></td>
                            <td style={s.td}>
                              <button style={{ ...s.btn, background: "rgba(167,139,250,0.08)", color: "#a78bfa", borderColor: "rgba(167,139,250,0.2)" }} onClick={() => setRentalDetailCar(car)}>Voir</button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )
            )}

            {rentalTab === "payments" && (
              rentalPayments.length === 0 ? (
                <p style={s.emptyMsg}>Aucun paiement de location enregistré</p>
              ) : (
                <div style={s.tableWrap}>
                  <table style={s.table}>
                    <thead>
                      <tr>{["Client","Véhicule","Période","Montant total","Commission (10%)","Part transporteur (90%)","Opérateur","Statut","Date"].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
                    </thead>
                    <tbody>
                      {rentalPayments.map((p, i) => {
                        const total       = Number(p.amount || 0);
                        const commission  = Math.round(total * 0.1);
                        const transPart   = Math.round(total * 0.9);
                        const status      = (p.status ?? "pending").toUpperCase();
                        const rb          = p.rentalBooking;
                        const days        = rb ? Math.max(1, Math.ceil((new Date(rb.endDate) - new Date(rb.startDate)) / 86400000)) : "—";
                        return (
                          <tr key={p.id ?? i} className="trow">
                            <td style={s.td}>
                              <div>
                                <div style={{ color: "#e8e9ed", fontWeight: 600, fontSize: 13, whiteSpace: "nowrap" }}>{rb?.customer?.name ?? "—"}</div>
                                {rb?.customer?.email && <div style={{ fontSize: 10, color: "#8b8fa8" }}>{rb.customer.email}</div>}
                              </div>
                            </td>
                            <td style={s.td}>
                              {rb?.car ? (
                                <div style={{ whiteSpace: "nowrap" }}>
                                  <div style={{ color: "#c8cad8", fontSize: 13, fontWeight: 600 }}>{rb.car.brand} {rb.car.model}</div>
                                </div>
                              ) : <span style={{ color: "#4a4d5e" }}>—</span>}
                            </td>
                            <td style={s.td}>
                              {rb ? (
                                <div style={{ fontSize: 11, color: "#8b8fa8", whiteSpace: "nowrap" }}>
                                  <div>{rb.startDate} → {rb.endDate}</div>
                                  <div style={{ color: "#60a5fa", marginTop: 2 }}>{days} jour{days > 1 ? "s" : ""}</div>
                                </div>
                              ) : "—"}
                            </td>
                            <td style={s.td}>
                              <div>
                                <div style={{ ...s.amount, color: "#a78bfa" }}>{total.toLocaleString()} MGA</div>
                                {rb?.totalPrice && Number(rb.totalPrice) !== total && (
                                  <div style={{ fontSize: 10, color: "#4a4d5a" }}>Prix résa : {Number(rb.totalPrice).toLocaleString()}</div>
                                )}
                              </div>
                            </td>
                            <td style={s.td}>
                              <div style={{ ...s.amount, color: "#4ade80", fontSize: 12 }}>{commission.toLocaleString()} MGA</div>
                              <div style={{ fontSize: 10, color: "#4a4d5a" }}>10 %</div>
                            </td>
                            <td style={s.td}>
                              <div style={{ ...s.amount, color: "#60a5fa", fontSize: 12 }}>{transPart.toLocaleString()} MGA</div>
                              <div style={{ fontSize: 10, color: "#4a4d5a" }}>90 %</div>
                            </td>
                            <td style={s.td}>{p.operator ? <span style={s.operatorTag}>{p.operator}</span> : <span style={{ color: "#4a4d5e" }}>—</span>}</td>
                            <td style={s.td}><Badge variant={statusVariant(status)}>{statusLabel(status)}</Badge></td>
                            <td style={{ ...s.td, color: "#8b8fa8", fontSize: 11, whiteSpace: "nowrap" }}>{p.createdAt ? new Date(p.createdAt).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "—"}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )
            )}
          </div>

          {/* CARPOOLS + RECENT BOOKINGS */}
          <div style={s.twoCol} className="two-col">
            <div style={s.card}>
              <div style={s.cardHeader}>
                <h2 style={s.cardTitle}>Covoiturages</h2>
                <Badge variant="info">{carpools.length} actifs</Badge>
              </div>
              {carpools.length === 0 ? <p style={s.emptyMsg}>Aucun covoiturage actif</p> : (
                <div style={s.tableWrap}>
                  <table style={s.table}>
                    <thead><tr>{["Transporteur","Itinéraire","Prix","Places"].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
                    <tbody>
                      {carpools.map(c => (
                        <tr key={c.id} className="trow">
                          <td style={s.td}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                              <Avatar name={c.transporterName} />
                              <span style={{ color: "#c8cad8", fontSize: 13, whiteSpace: "nowrap" }}>{c.transporterName}</span>
                            </div>
                          </td>
                          <td style={s.td}>
                            <div style={{ display: "flex", alignItems: "center", gap: 4, flexWrap: "wrap" }}>
                              {c.itinerary?.map((stop, i) => (
                                <React.Fragment key={i}>
                                  <span style={s.cityTag}>{stop.city}</span>
                                  {i < c.itinerary.length - 1 && <span style={{ color: "#2a2d38", fontSize: 10 }}>›</span>}
                                </React.Fragment>
                              ))}
                            </div>
                          </td>
                          <td style={s.td}><span style={s.amount}>{Number(c.price).toLocaleString()}</span></td>
                          <td style={s.td}><span style={s.seatsTag}>{c.seats} places</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div style={s.card}>
              <div style={s.cardHeader}>
                <h2 style={s.cardTitle}>Réservations récentes</h2>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <Badge variant="neutral">Dernières 24h</Badge>
                  <Link to="/admin/bookings" style={s.seeAll}>Voir tout →</Link>
                </div>
              </div>
              {recentBookings.length === 0 ? <p style={s.emptyMsg}>Aucune réservation récente</p> : (
                /* ── FIX: wrapper with explicit width:100% + overflow-x:auto ── */
                <div className="scroll-table-wrap">
                  <table style={s.table}>
                    <thead><tr>{["Client","Trajet","Montant","Statut"].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
                    <tbody>
                      {recentBookings.map((b, i) => (
                        <tr key={i} className="trow">
                          <td style={{ ...s.td, color: "#e8e9ed", fontWeight: 600, fontSize: 13, whiteSpace: "nowrap" }}>{b.client}</td>
                          <td style={{ ...s.td, color: "#8b8fa8", fontSize: 12 }}>{b.route}</td>
                          <td style={s.td}><span style={s.amount}>{Number(b.amount).toLocaleString()}</span></td>
                          <td style={s.td}><Badge variant={statusVariant(b.status)}>{statusLabel(b.status)}</Badge></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          {/* QUICK NAV */}
          <div style={s.quickNavGrid} className="quick-nav-grid">
            {[
              { to: "/admin/users",        icon: <UsersIcon />,  label: "Utilisateurs",  sub: `${stats.clients} comptes`,           color: "#4ade80" },
              { to: "/admin/transporters", icon: <TruckIcon />,  label: "Transporteurs", sub: `${stats.transporters} enregistrés`,  color: "#60a5fa" },
              { to: "/admin/bookings",     icon: <TicketIcon />, label: "Réservations",  sub: `${stats.bookings} au total`,         color: "#fbbf24" },
              { to: "/admin/revenue",      icon: <ChartIcon />,  label: "Revenus",       sub: "Analyse détaillée",                  color: "#a78bfa" },
            ].map(({ to, icon, label, sub, color }) => (
              <Link key={to} to={to} style={s.quickNavCard} className="quick-nav-card">
                <div style={{ ...s.quickNavIcon, background: `${color}15`, color }}>{icon}</div>
                <div style={s.quickNavLabel}>{label}</div>
                <div style={s.quickNavSub}>{sub}</div>
                <span style={{ ...s.quickNavArrow, color }}>→</span>
              </Link>
            ))}
          </div>

        </div>
      </div>

      {/* MODALS */}
      {approveTarget    && <ApprovePaymentModal  request={approveTarget}    onClose={() => setApproveTarget(null)}    onSuccess={handlePaymentActionSuccess} />}
      {rejectTarget     && <RejectPaymentModal   request={rejectTarget}     onClose={() => setRejectTarget(null)}     onSuccess={handlePaymentActionSuccess} />}
      {rentalDetailCar  && <RentalCarDetailModal car={rentalDetailCar}      onClose={() => setRentalDetailCar(null)} />}

      {detailTransporterId && (
        <TransporterDetailPanel
          transporterId={detailTransporterId}
          onClose={() => setDetailTransporterId(null)}
          onValidated={async () => { await loadPendingTransporters(); await loadStats(); showToast("Transporteur validé ✓", "success"); }}
          onRejected={async ()  => { await loadPendingTransporters(); showToast("Transporteur rejeté", "danger"); }}
        />
      )}

      <Toast toast={toast} />
      <BottomNav logout={logout} />
    </>
  );
};

const BottomNav = ({ logout }) => {
  const location = useLocation();
  const bottomItems = [
    { to: "/admin",              icon: <GridIcon />,   label: "Dashboard"    },
    { to: "/admin/users",        icon: <UsersIcon />,  label: "Utilisateurs" },
    { to: "/admin/transporters", icon: <TruckIcon />,  label: "Transporteurs"},
    { to: "/admin/bookings",     icon: <TicketIcon />, label: "Réservations" },
    { to: "/admin/revenue",      icon: <ChartIcon />,  label: "Revenus"      },
  ];
  return (
    <nav style={bn.bar} className="bottom-nav">
      {bottomItems.map(({ to, icon, label }) => {
        const active = location.pathname === to;
        return (
          <Link key={to} to={to} style={{ ...bn.item, color: active ? "#4ade80" : "#8b8fa8" }}>
            <span style={{ ...bn.icon, background: active ? "rgba(74,222,128,0.12)" : "transparent" }}>{icon}</span>
            <span style={{ fontSize: 10, fontWeight: active ? 700 : 500 }}>{label}</span>
          </Link>
        );
      })}
      <button style={{ ...bn.item, background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", color: "#8b8fa8" }} onClick={logout}>
        <span style={bn.icon}><LogoutIcon /></span>
        <span style={{ fontSize: 10 }}>Quitter</span>
      </button>
    </nav>
  );
};

const bn = {
  bar:  { display: "none", position: "fixed", bottom: 0, left: 0, right: 0, background: "#16181f", borderTop: "0.5px solid #2a2d38", zIndex: 200, padding: "6px 0 calc(6px + env(safe-area-inset-bottom))", justifyContent: "space-around", alignItems: "center" },
  item: { display: "flex", flexDirection: "column", alignItems: "center", gap: 4, textDecoration: "none", padding: "4px 6px", borderRadius: 8, minWidth: 48 },
  icon: { width: 32, height: 32, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" },
};

export default AdminDashboard;

/* ═══════════════════════════════════════════
   STYLES — MAIN
═══════════════════════════════════════════ */
const s = {
  layout:         { display: "flex", background: "#0f1117", minHeight: "100vh", fontFamily: "'Plus Jakarta Sans', sans-serif", overflow: "hidden" },
  sidebar:        { width: 220, background: "#16181f", borderRight: "0.5px solid #2a2d38", flexShrink: 0, position: "sticky", top: 0, height: "100vh", overflow: "auto" },
  sidebarOpen:    { position: "fixed", left: 0, top: 0, zIndex: 200, height: "100%", width: 220 },
  sidebarInner:   { display: "flex", flexDirection: "column", height: "100%", padding: "0 0 24px" },
  sidebarLogoWrap:{ display: "flex", alignItems: "center", gap: 8, padding: "22px 20px 18px", borderBottom: "0.5px solid #2a2d38" },
  sidebarLogo:    { fontSize: 18, fontWeight: 700, letterSpacing: -0.5, color: "#e8e9ed" },
  adminPill:      { fontSize: 9, fontWeight: 700, background: "rgba(74,222,128,0.15)", color: "#4ade80", padding: "2px 7px", borderRadius: 20, textTransform: "uppercase", letterSpacing: 0.8 },
  nav:            { display: "flex", flexDirection: "column", gap: 2, padding: "12px 0", flex: 1 },
  navItem:        { display: "flex", alignItems: "center", gap: 10, padding: "9px 16px", fontSize: 13, color: "#8b8fa8", textDecoration: "none", position: "relative", transition: "all 0.12s" },
  navItemActive:  { color: "#e8e9ed", background: "rgba(255,255,255,0.04)" },
  navIcon:        { width: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  navActiveBar:   { position: "absolute", left: 0, top: 0, bottom: 0, width: 2, background: "#4ade80", borderRadius: "0 2px 2px 0" },
  sidebarFooter:  { padding: "0 12px", marginTop: "auto" },
  logoutBtn:      { display: "flex", alignItems: "center", gap: 8, padding: "10px 16px", fontSize: 13, color: "#8b8fa8", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", width: "100%", borderRadius: 8 },

  mobileTopbar:   { display: "none", alignItems: "center", justifyContent: "space-between", padding: "0 20px", height: 56, background: "#16181f", borderBottom: "0.5px solid #2a2d38", position: "sticky", top: 0, zIndex: 100, flexShrink: 0 },
  overlay2:       { position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 199 },
  hamburger:      { background: "none", border: "none", color: "#8b8fa8", cursor: "pointer", padding: 4 },

  main:           { flex: 1, minWidth: 0, maxWidth: "100%" },

  pageHeader:     { display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 24, gap: 12, flexWrap: "wrap" },
  pageTitle:      { fontSize: 20, fontWeight: 700, color: "#e8e9ed", letterSpacing: -0.4, margin: 0 },
  pageSubtitle:   { fontSize: 12, color: "#8b8fa8", marginTop: 3 },
  headerBtn:      { display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "#8b8fa8", textDecoration: "none", padding: "7px 12px", border: "0.5px solid #2a2d38", borderRadius: 8, background: "#16181f" },

  statsGrid:      { display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 14, marginBottom: 20 },
  statCard:       { background: "#16181f", border: "0.5px solid #2a2d38", borderRadius: 12, padding: "18px 20px", overflow: "visible" },
  statIcon:       { width: 32, height: 32, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 12, fontSize: 14 },
  statValue:      { fontSize: 20, fontWeight: 700, color: "#e8e9ed", letterSpacing: -0.5, marginBottom: 2 },
  statLabel:      { fontSize: 12, color: "#8b8fa8" },

  twoCol:         { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18, marginBottom: 18 },
  /* ── minWidth:0 est crucial : empêche le grid item de déborder ── */
  card:           { background: "#16181f", border: "0.5px solid #2a2d38", borderRadius: 12, padding: 20, marginBottom: 18, minWidth: 0 },
  cardHeader:     { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, flexWrap: "wrap", gap: 8 },
  cardTitle:      { fontSize: 14, fontWeight: 600, color: "#e8e9ed", margin: 0, letterSpacing: -0.2 },
  seeAll:         { fontSize: 11, color: "#4ade80", textDecoration: "none" },

  listRow:        { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "11px 0", borderBottom: "0.5px solid #1e2029", gap: 8, flexWrap: "wrap" },
  listRowLeft:    { display: "flex", alignItems: "center", gap: 10, minWidth: 0 },
  listName:       { fontSize: 13, fontWeight: 600, color: "#e8e9ed" },
  listSub:        { fontSize: 11, color: "#8b8fa8" },

  btnGroup:       { display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" },
  btn:            { fontSize: 11.5, padding: "5px 10px", borderRadius: 7, border: "0.5px solid", cursor: "pointer", fontFamily: "inherit", fontWeight: 500, transition: "all 0.15s", whiteSpace: "nowrap" },
  btnApprove:     { background: "rgba(74,222,128,0.1)", color: "#4ade80", borderColor: "rgba(74,222,128,0.25)" },
  btnReject:      { background: "rgba(248,113,113,0.1)", color: "#f87171", borderColor: "rgba(248,113,113,0.25)" },

  tableWrap:      { overflowX: "auto", WebkitOverflowScrolling: "touch" },
  table:          { width: "100%", borderCollapse: "collapse", fontSize: 13, minWidth: 480 },
  th:             { textAlign: "left", padding: "8px 12px", color: "#8b8fa8", fontSize: 10.5, fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "0.5px solid #2a2d38", background: "#13151b", whiteSpace: "nowrap" },
  td:             { padding: "11px 12px", borderBottom: "0.5px solid #1e2029", color: "#c8cad8", verticalAlign: "middle" },
  amount:         { fontFamily: "'DM Mono', monospace", fontSize: 13, color: "#4ade80", fontWeight: 600 },
  cityTag:        { fontSize: 11, background: "#1e2029", padding: "2px 7px", borderRadius: 5, color: "#8b8fa8" },
  seatsTag:       { fontSize: 11, background: "#1e2029", padding: "2px 7px", borderRadius: 5, color: "#8b8fa8", fontFamily: "'DM Mono', monospace" },
  operatorTag:    { fontSize: 11, background: "rgba(96,165,250,0.1)", color: "#60a5fa", padding: "2px 8px", borderRadius: 5, border: "0.5px solid rgba(96,165,250,0.2)", fontWeight: 600 },
  emptyMsg:       { fontSize: 13, color: "#8b8fa8", padding: "20px 0", textAlign: "center" },

  quickNavGrid:   { display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 14 },
  quickNavCard:   { background: "#16181f", border: "0.5px solid #2a2d38", borderRadius: 12, padding: "18px 20px", textDecoration: "none", display: "flex", flexDirection: "column", gap: 4, position: "relative", overflow: "hidden" },
  quickNavIcon:   { width: 32, height: 32, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 6 },
  quickNavLabel:  { fontSize: 13, fontWeight: 600, color: "#e8e9ed" },
  quickNavSub:    { fontSize: 11, color: "#8b8fa8" },
  quickNavArrow:  { position: "absolute", bottom: 18, right: 20, fontSize: 16, fontWeight: 700 },

  loadingScreen:  { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#0f1117" },
  spinner:        { display: "inline-block", width: 20, height: 20, border: "2px solid #2a2d38", borderTopColor: "#4ade80", borderRadius: "50%", animation: "spin 0.6s linear infinite" },

  toast:          { position: "fixed", bottom: 24, right: 24, background: "#16181f", border: "0.5px solid #2a2d38", padding: "12px 20px", borderRadius: 10, fontSize: 13, color: "#e8e9ed", zIndex: 999, display: "flex", alignItems: "center", gap: 8, boxShadow: "0 8px 24px rgba(0,0,0,0.4)" },
  toastDot:       { width: 8, height: 8, borderRadius: "50%", flexShrink: 0 },

  overlay:        { position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", backdropFilter: "blur(6px)", zIndex: 500, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 },
  modal:          { background: "#16181f", border: "0.5px solid #2a2d38", borderRadius: 16, width: "100%", maxWidth: 520, boxShadow: "0 32px 80px rgba(0,0,0,0.5)", overflow: "hidden" },
  modalHeader:    { display: "flex", alignItems: "flex-start", justifyContent: "space-between", padding: "20px 24px", borderBottom: "0.5px solid #2a2d38" },
  modalIconWrap:  { width: 34, height: 34, borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  modalTitle:     { fontSize: 15, fontWeight: 700, color: "#e8e9ed", lineHeight: 1.2 },
  modalSub:       { fontSize: 11.5, color: "#8b8fa8", marginTop: 3 },
  closeBtn:       { background: "none", border: "none", cursor: "pointer", color: "#8b8fa8", padding: 4, display: "flex", flexShrink: 0, marginLeft: 8 },
  modalBody:      { padding: "20px 24px" },
  modalFooter:    { padding: "16px 24px", borderTop: "0.5px solid #2a2d38", display: "flex", gap: 10, justifyContent: "flex-end" },

  requestSummary: { background: "#13151b", border: "0.5px solid #2a2d38", borderRadius: 12, padding: "16px 18px", marginBottom: 20 },
  summaryRow:     { display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 },
  summaryName:    { fontSize: 14, fontWeight: 700, color: "#e8e9ed" },
  summarySub:     { fontSize: 11, color: "#8b8fa8", marginTop: 2 },
  summaryAmount:  { fontFamily: "'DM Mono', monospace", fontSize: 20, fontWeight: 700, color: "#4ade80", letterSpacing: -0.5 },
  summaryDivider: { height: 0.5, background: "#2a2d38", margin: "14px 0" },
  summaryGrid:    { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  summaryItem:    {},
  summaryItemLabel: { fontSize: 10.5, color: "#8b8fa8", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 600, marginBottom: 4 },
  summaryItemVal: { fontSize: 13, color: "#c8cad8", display: "flex", alignItems: "center", gap: 5 },

  codeSection:    { background: "rgba(74,222,128,0.04)", border: "0.5px solid rgba(74,222,128,0.15)", borderRadius: 10, padding: "16px 18px" },
  codeLabel:      { fontSize: 12, fontWeight: 700, color: "#4ade80", marginBottom: 8, display: "flex", alignItems: "center", gap: 6 },
  codeHint:       { fontSize: 12, color: "#8b8fa8", lineHeight: 1.6, margin: "0 0 12px" },
  codeInput:      { width: "100%", padding: "11px 14px", background: "#1e2029", border: "0.5px solid #3a3d4a", borderRadius: 9, fontSize: 14, fontFamily: "'DM Mono', monospace", color: "#e8e9ed", outline: "none", boxSizing: "border-box", letterSpacing: 0.5 },
  codeInputError: { borderColor: "rgba(248,113,113,0.5)", background: "rgba(248,113,113,0.04)" },
  errMsg:         { display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "#f87171", marginTop: 8 },

  rejectWarning:  { background: "rgba(248,113,113,0.06)", border: "0.5px solid rgba(248,113,113,0.2)", borderRadius: 10, padding: "14px 16px" },
  rejectWarningText: { fontSize: 13, color: "#c8cad8", lineHeight: 1.6 },

  cancelBtn:      { padding: "9px 18px", background: "none", border: "0.5px solid #2a2d38", borderRadius: 9, fontSize: 13, color: "#8b8fa8", cursor: "pointer", fontFamily: "inherit" },
  approveBtn:     { padding: "9px 20px", background: "rgba(74,222,128,0.12)", border: "0.5px solid rgba(74,222,128,0.3)", borderRadius: 9, fontSize: 13, fontWeight: 600, color: "#4ade80", cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", gap: 6 },
  rejectBtn:      { padding: "9px 20px", background: "rgba(248,113,113,0.12)", border: "0.5px solid rgba(248,113,113,0.3)", borderRadius: 9, fontSize: 13, fontWeight: 600, color: "#f87171", cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", gap: 6 },
};

/* ═══════════════════════════════════════════
   STYLES — DETAIL PANEL
═══════════════════════════════════════════ */
const dp = {
  backdrop:   { position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", zIndex: 300 },
  panel:      { position: "fixed", top: 0, right: 0, bottom: 0, width: "min(540px,100vw)", background: "#16181f", borderLeft: "0.5px solid #2a2d38", zIndex: 301, display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "-20px 0 60px rgba(0,0,0,0.4)", fontFamily: "'Plus Jakarta Sans', sans-serif" },
  header:     { display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, padding: "20px 24px 16px", borderBottom: "0.5px solid #2a2d38", flexShrink: 0 },
  closeBtn:   { background: "none", border: "none", cursor: "pointer", color: "#8b8fa8", padding: 6, display: "flex", borderRadius: 6, flexShrink: 0 },
  contactBar: { display: "flex", gap: 8, padding: "12px 24px", borderBottom: "0.5px solid #1e2029", flexShrink: 0, flexWrap: "wrap" },
  chip:       { display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, color: "#8b8fa8", background: "#1e2029", border: "0.5px solid #2a2d38", borderRadius: 7, padding: "5px 10px", textDecoration: "none", fontFamily: "'Plus Jakarta Sans', sans-serif", maxWidth: "100%" },
  tabBar:     { display: "flex", borderBottom: "0.5px solid #2a2d38", flexShrink: 0, overflowX: "auto" },
  tab:        { padding: "11px 16px", fontSize: 12, fontWeight: 500, color: "#8b8fa8", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", borderBottom: "2px solid transparent", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: 5 },
  tabActive:  { color: "#e8e9ed", borderBottomColor: "#4ade80" },
  tabBadge:   { fontSize: 10, background: "rgba(74,222,128,0.15)", color: "#4ade80", padding: "1px 5px", borderRadius: 4, fontWeight: 700 },
  body:       { flex: 1, overflowY: "auto", padding: "20px 24px" },
  footer:     { padding: "16px 24px", borderTop: "0.5px solid #2a2d38", background: "#13151b", flexShrink: 0 },
  validateBtn:{ flex: 1, padding: "10px 18px", background: "rgba(74,222,128,0.12)", border: "0.5px solid rgba(74,222,128,0.3)", borderRadius: 9, fontSize: 13, fontWeight: 700, color: "#4ade80", cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 },
  rejectBtn:  { padding: "10px 18px", background: "rgba(248,113,113,0.08)", border: "0.5px solid rgba(248,113,113,0.2)", borderRadius: 9, fontSize: 13, fontWeight: 600, color: "#f87171", cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", gap: 6 },
  section:    { background: "#13151b", border: "0.5px solid #2a2d38", borderRadius: 12, padding: "16px 18px" },
  sectionTitle:{ fontSize: 10.5, fontWeight: 700, color: "#4ade80", textTransform: "uppercase", letterSpacing: "0.7px", marginBottom: 14 },
  infoGrid:   { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px 20px" },
  docRow:     { display: "flex", alignItems: "center", gap: 12, background: "#13151b", border: "0.5px solid #2a2d38", borderRadius: 10, padding: "12px 14px" },
  docBtn:     { display: "flex", alignItems: "center", gap: 4, fontSize: 11, color: "#60a5fa", background: "rgba(96,165,250,0.08)", border: "0.5px solid rgba(96,165,250,0.2)", borderRadius: 6, padding: "5px 10px", cursor: "pointer", fontFamily: "inherit", flexShrink: 0 },
  empty:      { fontSize: 13, color: "#4a4d5e", textAlign: "center", padding: "32px 0" },
  table:      { width: "100%", borderCollapse: "collapse", fontSize: 12 },
  th:         { textAlign: "left", padding: "7px 10px", color: "#8b8fa8", fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "0.5px solid #2a2d38", background: "#0f1117", whiteSpace: "nowrap" },
  td:         { padding: "10px 10px", borderBottom: "0.5px solid #1e2029", color: "#c8cad8", verticalAlign: "middle" },
};

/* ═══════════════════════════════════════════
   GLOBAL CSS
═══════════════════════════════════════════ */
const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
  @keyframes spin    { to { transform: rotate(360deg); } }
  @keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
  @keyframes slideInLeft { from { transform: translateX(-100%); } to { transform: translateX(0); } }

  * { box-sizing: border-box; }

  /* ═══════════ SIDEBAR ═══════════ */
  .admin-sidebar { display: flex; flex-direction: column; }
  .admin-sidebar.hidden { display: none !important; }
  .nav-link:hover    { color: #e8e9ed !important; background: rgba(255,255,255,0.03) !important; }
  .logout-btn:hover  { color: #f87171 !important; }

  /* ═══════════ MAIN ═══════════ */
  .admin-main { padding: 28px 24px; }

  /* ═══════════ SCROLL TABLE WRAP ═══════════ */
  /*
   * Fix scroll horizontal sur les tableaux dans un grid.
   * Le grid item a minWidth:0 (dans s.card).
   * Ce wrapper force le débordement horizontal visible avec une
   * scrollbar stylisée toujours présente sur mobile.
   */
  .scroll-table-wrap {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  /* Scrollbar visible et stylisée (WebKit) */
  .scroll-table-wrap::-webkit-scrollbar {
    height: 4px;
  }
  .scroll-table-wrap::-webkit-scrollbar-track {
    background: #1e2029;
    border-radius: 4px;
  }
  .scroll-table-wrap::-webkit-scrollbar-thumb {
    background: #3a3d4a;
    border-radius: 4px;
  }
  .scroll-table-wrap::-webkit-scrollbar-thumb:hover {
    background: #4ade80;
  }
  /* Firefox */
  .scroll-table-wrap {
    scrollbar-width: thin;
    scrollbar-color: #3a3d4a #1e2029;
  }

  /* ═══════════ INTERACTIONS ═══════════ */
  button:disabled    { opacity: 0.4; cursor: not-allowed !important; }
  .trow:hover td     { background: #1a1c25 !important; }
  .stat-card:hover   { border-color: #3a3d4a !important; }
  .quick-nav-card:hover { border-color: #3a3d4a !important; transform: translateY(-1px); transition: all 0.15s; }
  .header-btn:hover  { color: #e8e9ed !important; border-color: #3a3d4a !important; }

  /* ═══════════ DETAIL PANEL ═══════════ */
  .detail-panel { animation: slideIn 0.22s cubic-bezier(0.22,1,0.36,1); }
  .dp-chip:hover     { border-color: rgba(74,222,128,0.3) !important; color: #e8e9ed !important; }
  .dp-tab:hover      { color: #e8e9ed !important; }
  .dp-doc-btn:hover  { background: rgba(96,165,250,0.15) !important; }
  .detail-panel ::-webkit-scrollbar       { width: 4px; }
  .detail-panel ::-webkit-scrollbar-track { background: transparent; }
  .detail-panel ::-webkit-scrollbar-thumb { background: #2a2d38; border-radius: 4px; }

  /* ═══════════ TOAST ═══════════ */
  .admin-toast { animation: slideIn 0.2s ease; }

  /* ═══════════ GRIDS — desktop ═══════════ */
  .stats-grid     { grid-template-columns: repeat(5, 1fr) !important; }
  .two-col        { grid-template-columns: 1fr 1fr; }
  .quick-nav-grid { grid-template-columns: repeat(4, 1fr); }
  .rental-stats-grid { grid-template-columns: repeat(3, 1fr); }

  /* ═══════════ TABLET ≤ 1200px ═══════════ */
  @media (max-width: 1200px) {
    .stats-grid     { grid-template-columns: repeat(3, 1fr) !important; }
    .quick-nav-grid { grid-template-columns: 1fr 1fr !important; }
    .admin-main     { padding: 20px 16px; }
  }

  /* ═══════════ TABLET ≤ 992px — sidebar cachée ═══════════ */
  @media (max-width: 992px) {
    .admin-sidebar {
      display: none !important;
      width: 0 !important;
    }
    .mobile-topbar { display: flex !important; }
    .bottom-nav { display: none; }
    .bottom-nav { display: flex !important; }

    .admin-main {
      width: 100% !important;
      padding: 16px 14px 96px !important;
    }

    .two-col        { grid-template-columns: 1fr !important; }
    .stats-grid     { grid-template-columns: repeat(2, 1fr) !important; gap: 10px !important; }
    .quick-nav-grid { grid-template-columns: 1fr 1fr !important; gap: 10px !important; }
    .rental-stats-grid { grid-template-columns: 1fr !important; gap: 10px !important; }
  }

  /* ═══════════ MOBILE ≤ 640px ═══════════ */
  @media (max-width: 640px) {
    .admin-main     { padding: 12px 12px 24px !important; }
    .stats-grid     { grid-template-columns: 1fr 1fr !important; gap: 8px !important; }
    .quick-nav-grid { grid-template-columns: 1fr 1fr !important; }
    .rental-stats-grid { grid-template-columns: 1fr !important; }
    .two-col        { grid-template-columns: 1fr !important; }
  }

  /* ═══════════ TRÈS PETIT ≤ 420px ═══════════ */
  @media (max-width: 420px) {
    .stats-grid     { grid-template-columns: 1fr !important; }
    .quick-nav-grid { grid-template-columns: 1fr !important; }
  }
`;